import $ from "jquery";

$(function () {
    $(".bl-counters").each(function () {
        const $bl = $(this);
        initBlock($bl);
    });
});

function initBlock($bl) {
    const options = {
        root: null, //null=window
        rootMargin: "0% 0% -20% 0%", //unten -20%
        threshold: 0 //triggert, wenn Element zu 0% sichtbar (innerhalb rootMargin) => 0% = triggert sofort, wenn nur ein bisschen sichtbar. Noetig fuer grosse Elemente.
    };

    const observer = new IntersectionObserver(handleIntersect, options);
    observer.observe($bl.get(0));

    function handleIntersect(entries, observer) {
        startCounting();
    }

    function startCounting() {
        const $numbers = $(".counter");

        $numbers.each(function () {
            const $number = $(this);
            const targetNumber = parseInt($number.data("targetnumber"));
            const isVertical = $number.data("vertical") == 1;
            const unit = $number.data("unit");
            const suffix = (unit != "" ? " "+unit : "");

            $({ counterValue: 0 }).animate(
                { counterValue: targetNumber },
                {
                    duration: 2000, //Animation duration in milliseconds
                    easing: 'swing',
                    step: function () {
                        // Update the element's text with the current animated value, rounded up
                        $number.html(formatText(Math.ceil(this.counterValue), suffix, isVertical));
                    },
                    // Callback function to execute once the animation is complete
                    complete: function () {
                        // Ensure the final value is exactly the target number, to avoid rounding errors
                        $number.html(formatText(targetNumber, suffix, isVertical));
                    }
                }
            );
        });
    }
}

function formatText(text, suffix, vertical) {
    let result = text + suffix;
    if (vertical) {
        // add <br> after each character
        result = result
            .split('')
            .map(ch => ch + '<br>')
            .join('');
    }
    return result;
}
